// extracted by mini-css-extract-plugin
module.exports = {"root":"UnreadMsg_root__1iuip","content":"UnreadMsg_content__11907"};